<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: true,
				showClose: false
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal.vue